export const WHATSAPP_COUNTRIES = [
  { label: '+55 (Brasil)', value: '+55' },
  { label: '+54 (Argentina)', value: '+54' },
  { label: '+52 (México)', value: '+52' },
  { label: '+56 (Chile)', value: '+56' },
  { label: '+57 (Colômbia)', value: '+57' },
  { label: '+51 (Peru)', value: '+51' },
  { label: '+58 (Venezuela)', value: '+58' },
  { label: '+591 (Bolívia)', value: '+591' },
  { label: '+595 (Paraguai)', value: '+595' },
  { label: '+598 (Uruguai)', value: '+598' },
  { label: '+1 (EUA / Canadá)', value: '+1' },
  { label: '+351 (Portugal)', value: '+351' },
  { label: '+34 (Espanha)', value: '+34' },
];

export type WhatsappCountryCode = (typeof WHATSAPP_COUNTRIES)[number]['value'];

export type TStore = {
  store_id: number;
  nome: string;
  dominio?: string;
  email: string;
  telefone?: string;
  whatsapp_pais?: WhatsappCountryCode;
  whatsapp_numero?: string;
  pais: 'BR' | 'MX' | 'AR' | 'CO' | 'CL';
  idioma?: string;
  moeda?: string;
  cnpj?: string;
  razon_social?: string;
  documento_fiscal?: string;
  endereco: {
    rua?: string;
    numero?: string;
    bairro?: string;
    cidade?: string;
    estado?: string;
    cep?: string;
    complemento?: string;
  };
  stripe_customer_id?: string;
  criado_em: Date;
};
